export default {
  PAGE_VIEW: 'pageview',
};
